import { apiClient } from './client';

export const dqbApi = apiClient.injectEndpoints({
    endpoints: (builder) => ({
        dqb: builder.mutation<void, { book_id: any }>({
            query: ({ book_id }) => ({
                url: '/api/dqb',
                method: 'POST',
                body: { book_id },
            }),
        }),
    }),
});

export const { useDqbMutation } = dqbApi;
